// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd48682c","732":"3c42347a","977":"e997ba23"}[chunkId] + ".chunk.js";
};